import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ArrayFilterPipe } from '../../pipes/array-filter.pipe';
import { addCountToBasket, addToBasket, deleteFromBasket, removeFromBasket } from '../../store/actions/basket.actions';
import { closeBasketAndParts, updatePage } from '../../store/actions/config.actions';
import { CONFIG } from '../../store/reducer/config.reducer';
import { DATA } from '../../store/reducer/data.reducer';
declare const window: any;
@Component({
  selector: 'app-parts',
  templateUrl: './parts.component.html',
  styleUrls: ['./parts.component.scss'],
  standalone: false
})
export class PartsComponent implements OnChanges, OnDestroy {
  @Input() config: CONFIG;

  basket$: Observable<{}> = this.store.select((state) => state.basket);
  cartCount = 0;
  selectedData;
  selectedPiece;

  private _selectedData$: Subscription;

  constructor(private arrayFilterPipe: ArrayFilterPipe, private store: Store<{ data: DATA; basket: {} }>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['config'] &&
      changes['config'].currentValue &&
      changes['config'].previousValue &&
      changes['config'].currentValue['currentPageNumber'] !== changes['config'].previousValue['currentPageNumber']
    ) {
      if (this._selectedData$) this._selectedData$.unsubscribe();
      this._selectedData$ = this.store.select('data').subscribe((data) => {
        data.pages.forEach((d) => {
          const resultData = this.arrayFilterPipe
            .transform(d.page, String(this.config.currentPageNumber), 'numpage')
            .filter((d) => d.piece);
          if (resultData.length > 0) {
            this.selectedData = resultData[0];
            window.selectedData = this.selectedData;
          }
        });
      });
    }

    if (changes.config?.currentValue?.currentLoadedPage !== changes.config?.previousValue?.currentLoadedPage && this.selectedPiece) {
      setTimeout(() => {
        this.hoverPiece(this.selectedPiece);
        this.selectedPiece = null;
      }, 500);
    }
  }

  hideIsPartsVisible() {
    this.store.dispatch(closeBasketAndParts());
  }

  addToBasket(uid, itemId, id, piece) {
    this.store.dispatch(addToBasket(uid, itemId, id, piece));
  }

  addCountToBasket(uid, itemId, id, piece, value) {
    this.store.dispatch(addCountToBasket(uid, itemId, id, piece, Number(value)));
  }

  removeFromBasket(uid, itemId, id) {
    this.store.dispatch(removeFromBasket(uid, itemId, id));
  }

  deleteFromBasket(piece) {
    this.store.dispatch(deleteFromBasket(piece.uid, piece.currentPageNumber, piece.id));
    this.removeHoverPiece(piece);
  }

  navigateToPartPage(piece) {
    if (!this.config.isBasketVisible) return;
    const pageNumber = piece.currentPageNumber;
    this.store.dispatch(updatePage(Number(pageNumber)));
    this.hoverPiece(piece);
    this.selectedPiece = piece;
  }

  hoverPiece(piece) {
    const _selectedData: any[] = Array.isArray(this.selectedData.piece) ? this.selectedData.piece : [this.selectedData.piece];
    if (!_selectedData.some((d) => d.numident === piece.numident)) return;

    const elm = document.querySelectorAll(`[itemnumber="${piece.id}"]`);
    const elm2 = document.querySelectorAll(`[id="hotspot.${piece.id}"]`);
    const allElms = Array.from(elm).concat(Array.from(elm2));
    for (let index = 0; index < allElms.length; index++) {
      const element = elm[index];
      element.classList.add('hotspot-active');

      let evt = {
        path: [element]
      };

      window.ShowToolTip(evt, piece.id, null);
    }
  }

  removeHoverPiece(piece) {
    const elm = document.querySelectorAll(`[itemnumber="${piece.id}"]`);

    for (let index = 0; index < elm.length; index++) {
      const element = elm[index];
      element.classList.remove('hotspot-active');
    }

    if (window.activeTippy) {
      window.activeTippy.destroy();
      window.activeTippy = null;
    }
  }

  ngOnDestroy() {
    this._selectedData$ && this._selectedData$.unsubscribe();
  }

  public tryGuessName(actualItem: any) {
    // if node is empty, xmlToJson set its value to {}
    let name = actualItem['desan'];
    if (name && typeof name === 'string') {
      return name;
    }
    name = actualItem['desfr'];
    if (name && typeof name === 'string') {
      return name;
    }
    name = actualItem['desal'];
    if (name && typeof name === 'string') {
      return name;
    }
    return actualItem['numident'];
  }
}
